/** @jsx jsx */
import { ClassNames, jsx } from '@emotion/react';
import { AfterPage, AfterPageProps } from '@sprinx/after-razzle';
import pressReleases from 'api/pressReleasesData';
import Breadcrumbs from 'components/Breadcrumbs';
import Page from 'components/Page';
import MainLayout from 'layouts/MainLayout';
import ErrorPage from 'pages/ErrorPage';
import NotFoundPage from 'pages/NotFoundPage/NotFoundPage';
import LocalizationProvider from 'providers/LocalizationProvider';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { routeUrl } from 'routesBuilder';
import { PressReleasesData } from 'types/PressReleasesData';
import { SupportedLocale, SupportedRegion } from 'types/Supported';
import PressReleaseCertification from './components/PressReleaseCertification';
import PressReleaseIntroduction from './components/PressReleaseIntroduction';
import PressReleaseNews from './components/PressReleaseNews';

export interface PressReleasesProps extends AfterPageProps<PressReleasesRouteParams> {
  data?: PressReleasesData;
  locale: SupportedLocale;
  region: SupportedRegion;
}

interface PressReleasesRouteParams {
  id?: string;
  locale: SupportedLocale;
  region: SupportedRegion;
}

const PressReleases: AfterPage<PressReleasesRouteParams, PressReleasesProps> = ({ data, error, locale, region }) => {
  if (error) return <ErrorPage locale={locale} region={region} error={error} />;
  if (!data) return <NotFoundPage locale={locale} region={region} />;

  const { layout, certifications, pressReleases, pressNews } = data;

  return (
    <LocalizationProvider locale={locale} region={region}>
      <ClassNames>
        {({ theme }) => (
          <MainLayout locale={locale} {...layout}>
            <Page
              breadcrumbs={
                <Breadcrumbs>
                  <Link to={routeUrl('home', { locale, params: { locale: locale, region: region } })}>AppOn.cloud</Link>
                  <Link
                    to={routeUrl('press', { locale, params: { locale: locale, region: region } })}
                    className='active'
                  >
                    <FormattedMessage id={'navigation.forpress'} />
                  </Link>
                </Breadcrumbs>
              }
              pageTitle={data.title}
              css={{ width: '100%' }}
            >
              <PressReleaseIntroduction />
              <div
                css={{
                  alignItems: 'center',
                  background: theme.palette.backgroundGradient,
                  display: 'flex',
                  flexDirection: 'column',
                  flexGrow: 1,
                  width: '100%',
                }}
              >
                <PressReleaseNews pressReleases={pressReleases} pressNews={pressNews} />
                {/* <PressReleaseForm /> */}
              </div>
              <PressReleaseCertification certifications={certifications} />
            </Page>
          </MainLayout>
        )}
      </ClassNames>
    </LocalizationProvider>
  );
};

PressReleases.getInitialProps = async ({ match }) => {
  const { locale, region } = match.params;
  const data = await pressReleases.get({ locale, region });

  return {
    data,
    locale,
    region,
  };
};

export default PressReleases;
